import api from "@/api/api-v2-config";


export async function getBatchProductionListAxios() {    
    return await api.get("jobcards/batch?pageNumber=1&pageSize=1000");
}

export async function postBatchProductionAxios(batchProduction) {    
    return await api.post("jobcards/batch", batchProduction);
}

export async function putBatchProductionAxios(batchProduction) {    
    return await api.put("jobcards/batch", batchProduction);
}

export async function deleteBatchProductionAxios(id) {    
    return await api.delete("jobcards/deletebatch?Id=" + id);
}